import React, { Component } from 'react';

import i18n from '../i18n/i18n';

import {
        AppBar,
        Toolbar,
        Typography,
        IconButton
} from '@mui/material';

import {
        Close as CloseIcon,
        Menu as MenuIcon,
        Replay as ReplayIcon
} from '@mui/icons-material';

import './Header.scss';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menuAction: props.menuAction,
            activeMenu: props.activeMenu,
            disabledMenu: props.disabledMenu,
            disabledLanguage: props.disabledLanguage
        };
        
        this.reloadThePage = this.reloadThePage.bind(this);
    }

    reloadThePage() {

        window.location.reload();
    }

    render() {
        
        return (<AppBar position="fixed" color="inherit" elevation={0} className="appBar">
            <Toolbar>
                { this.props.disabledMenu === false ?
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    onClick={this.props.menuAction}
                    edge="start"
                    className="menuButton"
                    >
                    {this.props.activeMenu ? <CloseIcon/> : <MenuIcon/>}
                </IconButton>
                : '' }
                <Typography variant="h6" noWrap component="div">
                    Smart Guide
                </Typography>
                { this.state.disabledLanguage === false ?
                <select
                    className="languageSelect"
                    value={this.props.locale || i18n.language}
                    onChange={(e) => this.props.changeLocale(e.target.value)}
                >
                    <option value="en"  className="languageSelectOptions">EN</option>
                    <option value="es"  className="languageSelectOptions">ES</option>
                    <option value="it"  className="languageSelectOptions">IT</option>
                    <option value="fr"  className="languageSelectOptions">FR</option>
                    <option value="de"  className="languageSelectOptions">DE</option>
                    <option value="ru"  className="languageSelectOptions">RU</option>
                    <option value="ro"  className="languageSelectOptions">RO</option>
                    <option value="zh"  className="languageSelectOptions">ZH</option>
                    <option value="bg"  className="languageSelectOptions">BG</option>
                    <option value="ua"  className="languageSelectOptions">UA</option>
                    <option value="pt"  className="languageSelectOptions">PT</option>
                    <option value="pl"  className="languageSelectOptions">PL</option>
                </select>
                : '' }
            </Toolbar>
        </AppBar>);
    }
    ;
}
;

export default Header;